import { AssetsSvgMap, TWidget } from '@libs/types';
import clsx from 'clsx';
import DOMPurify from 'dompurify';
import parse from 'html-react-parser';
import React from 'react';
import { SvgComponent } from '../../../common/Svg/SvgComponent';
import { TConsumerListData } from '../../../types/data';
import { TRowOption } from '../../../types/options';
import { getInlineStyles } from '../../../utils/styles';
import { Visual } from '../../Image/Visual';
import { TextCommon } from '../Text/TextCommon';
import { TRowRegular } from './RowRegular';
import styles from './styles/selector.module.css';

export const Selector = (props: TRowRegular) => {
    const finalWidget = {
        uid: props.uid,
        data: {
            title: props.title,
            subtitle: props.subtitle,
            metaText: props.metaText,
        },
        options: {
            isDisabled: props.isDisabled ?? false,
            isHide: props.isHide ?? false,
            iconName: props.iconName,
            defaultIconName: props.defaultIconName,
            flagIcon: props.flagIcon,
            avatar: props.avatar,
            isSelected: props.isSelected,
            iconHierarchy: props.iconHierarchy,
            iconVariant: props.iconVariant,
            margin: props.margin,
        },
    } as TWidget<TConsumerListData, TRowOption>;

    const isDisabled = finalWidget.options.isDisabled;

    const iconName = finalWidget.options?.iconName;
    const defaultIconName = finalWidget.options?.defaultIconName;
    const flagIcon = finalWidget.options?.flagIcon;
    const avatar = finalWidget.options?.avatar;
    const isSelected = finalWidget.options?.isSelected;
    const getTextColor = isDisabled ? 'grey_40_lc' : 'grey_72_lc';
    const showVisual = iconName || flagIcon || avatar;

    return (
        <button
            data-test={finalWidget?.uid}
            className={clsx(styles.commonSelector, isDisabled && styles.disabled)}
            style={getInlineStyles({ margin: finalWidget.options.margin })}
            onClick={props.handleClick}
            aria-label={finalWidget.data?.title}
            aria-disabled={isDisabled}
            disabled={isDisabled}
        >
            {showVisual && (
                <div className={styles.visualWrapper}>
                    {iconName && (
                        <Visual
                            isWidget={false}
                            iconName={iconName}
                            defaultIconName={defaultIconName}
                            rightMargin
                            iconHierarchy={finalWidget.options?.iconHierarchy}
                            iconVariant={finalWidget.options?.iconVariant}
                            size={'small'}
                            isDisabled={isDisabled}
                        />
                    )}
                    {flagIcon && <Visual isWidget={false} rightMargin flagIcon={flagIcon} size={'small'} isDisabled={isDisabled} />}
                    {avatar && <Visual isWidget={false} avatar={avatar} rightMargin size={'small'} />}
                    {isSelected && (
                        <div className={styles.selectedBadge}>
                            <SvgComponent name={AssetsSvgMap.ic_check} fill="purple_100" />
                        </div>
                    )}
                </div>
            )}
            <div className={styles.rowContent}>
                {finalWidget.data?.title && (
                    <div className={clsx(styles.highlightedTitle, isDisabled && styles.disabled)}>{parse(DOMPurify.sanitize(finalWidget.data?.title))}</div>
                )}
                {finalWidget.data?.subtitle && (
                    <TextCommon
                        isWidget={false}
                        content={finalWidget.data?.subtitle}
                        options={{
                            variant: 'secondary',
                            textColor: getTextColor,
                            margin: { top: 4 },
                        }}
                    />
                )}
            </div>
            {finalWidget.data?.metaText && (
                <TextCommon isWidget={false} content={finalWidget.data?.metaText} options={{ textColor: isDisabled ? 'grey_40_lc' : 'grey_72_lc' }} />
            )}
            {!iconName && !flagIcon && !avatar && isSelected && (
                <SvgComponent name={AssetsSvgMap.ic_check} fill={!isDisabled ? 'purple_100' : 'purple_40_tr'} />
            )}
        </button>
    );
};
